import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('get', `/api/live_discussions/${id}/summary-data`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/getSummaryTableData.js